import { Injectable, signal } from "@angular/core";

@Injectable()
export class FiFormErrorDisplayContextService {
    readonly showValidationErrors = signal(false);

    show(): void {
      this.showValidationErrors.set(true);
    }
  
    hide(): void {
      this.showValidationErrors.set(false);
    }
}